import "./Flow.js";
import { MarkerType } from "reactflow";
import { insertValues } from "./Maths.js";
import { nodes } from "./generator_new.js";
// import { importNodes, importEdges } from "./App.js";

/*
Parses .net files and returns nodes and edges

Editting very risky - somewhat thrown together to handle as much as possible from Netica and GENIE
TODO: Widen support for networks containing extra elements not supported by OLCA (e.g. text, other nodes)

If experiencing issues with import, try simplifying the network in the parent app (removing anything other than basic probability nodes + edges)
Or try importing via GENIE first, then exporting as .net from GENIE and importing into OLCA
*/

//Handles the file upload and passes to importNetwork
export function handleFile(file, setImport) {
  funcs["setImport"] = function (ns, es) {
    return setImport(ns, es);
  };
  file = file.target.files[0];
  let fileData = new FileReader();
  fileData.onloadend = importNetwork;
  fileData.readAsText(file);
}

let funcs = {};

function splitByCurlyBraces(str, maxDepth = 2) {
  //Splits string by curly braces, ignoring nested curly braces
  //Set a maxDepth (will add bounding) - returns the longest array of strings at that depth or less

  let bestResult = [];
  for (let targetDepth = 1; targetDepth <= maxDepth; targetDepth++) {
    let result = [];
    let depth = 0;
    let substr = "";
    for (let i = 0; i < str.length; i++) {
      if (str[i] === "{") {
        depth += 1;
        substr += str[i];
        continue;
      } else if (str[i] === "}") {
        if (depth === targetDepth) {
          substr += str[i];
          result.push(substr);
          substr = "";
        }
        depth -= 1;
        continue;
      }

      if (str[i] !== "{" && str[i] !== "}") {
        substr += str[i];
        continue;
      }
    }

    if (result.length > bestResult.length) {
      bestResult = result;
    }
  }

  return bestResult;
}

function parseNetwork(text) {
  //Move onto one line
  text = text
    .replace(/(\r\n|\n|\r)/gm, "")
    .replace(/['"]+/g, "")
    .replace(/\s\s+/g, " ")
    .trim();

  //Split by curly braces, ignoring nested curly braces
  let split = splitByCurlyBraces(text);

  //Edges
  let edges = [];
  let condProbs = [];
  for (let i = 0; i < split.length; i++) {
    let str = split[i];
    //Remove leading and trailing spaces, leading symbols
    str = str.trim().replace(/^[^a-zA-Z0-9]+/g, "");

    // Look for strings starting with "potential"
    if (str.startsWith("potential")) {
      // Get text inside first pair of parentheses
      let nodes = str.match(/\(([^)]+)\)/)[1];

      // Split by |
      nodes = nodes.split("|");
      let to = nodes[0].trim();
      let froms = nodes[1].trim().split(" ");

      for (let i = 0; i < froms.length; i++) {
        if (froms[i] === "") {
          continue;
        }
        edges.push({ source: froms[i], target: to });
      }

      //Remote text from string up until the word 'data'
      str = str.replace(/.*data/, "");

      // Get all numbers in the string, allowing decimal points. Don't allow numbers attached to letters, i.e. node4
      let numbers = str.match(/(?<![a-zA-Z])(\d+\.\d+|\d+)/g);

      let numbersArr = [];
      for (let i = 0; i < numbers.length; i++) {
        let num = parseFloat(numbers[i]);
        numbersArr.push(num);
      }
      numbers = numbersArr;
      let condProbObj = {};
      condProbObj[to] = numbers;
      condProbs.push(condProbObj);
    }
  }

  let nodes = [];
  for (let i = 0; i < split.length; i++) {
    let str = split[i];
    //Remove leading and trailing spaces, leading symbols
    str = str.trim().replace(/^[^a-zA-Z0-9]+/g, "");

    //If the string starts with "node", it's a node
    if (str.startsWith("node")) {
      // Id is after node, before space or ; or {
      let id = str.match(/node\s*([^;{]+)/);
      if (id !== undefined && id !== null) {
        id = id[1].trim();
        // Remove any spaces or symbols from the id
        id = id.replace(/[^a-zA-Z0-9]/g, "");
      } else {
        // TODO: THROW ERROR
      }

      //label is after title = or label =, and before next ;
      let label = str.match(/label\s*=\s*([^;]+)/);
      if (label === undefined || label === null) {
        label = str.match(/title\s*=\s*([^;]+)/);
      }
      if (label !== undefined && label !== null) {
        label = label[1];
      } else {
        // TODO: THROW ERROR
      }

      //States in the form states = ("present"  "no_fuel"); " may vary, spaces may vary
      let states = str.match(/states\s*=\s*\(([^;]+)\)/);

      if (states !== undefined && states !== null) {
        states = states[1].replace(/"/g, "").split(",");
        // Remove any symbols from the state
        for (let i = 0; i < states.length; i++) {
          states[i] = states[i].replace(/[^a-zA-Z0-9 ]/g, "");
          // If the state is empty, remove it
          if (states[i] === "") {
            states.splice(i, 1);
            i--;
          }
        }
      }
      let statesArr = [];
      for (let i = 0; i < states.length; i++) {
        let stateObj = {};
        stateObj[states[i]] = 0;
        statesArr.push(stateObj);
      }

      states = statesArr;

      let setStates = [];
      for (let i = 0; i < states.length; i++) {
        let title = "S" + (i + 1);
        let obj = {};
        obj[title] = 0;
        setStates.push(obj);
      }

      //parents are after parents = in form (parent1, parent2);
      let parents = str.match(/parents\s*=\s*\(([^;]+)\)/);
      if (parents !== undefined && parents !== null) {
        parents = parents[1].replace(/"/g, "").split(" ");
        // Use parents to make edges
        for (let i = 0; i < parents.length; i++) {
          if (parents[i] === "") {
            continue;
          }
          // Remove any spaces or symbols from the parents[i]
          parents[i] = parents[i].replace(/[^a-zA-Z0-9]/g, "");
          edges.push({ source: parents[i], target: id });
        }
      }

      // Position is either after position =, in the form (x y);
      // or like this: 	visual V1 {center = (333, 74);height = 1;}; with center = (x y)
      let position = str.match(/position\s*=\s*\(([^;]+)\)/);
      if (position === undefined || position === null) {
        position = str.match(/center\s*=\s*\(([^;]+)\)/);
      }
      if (position !== undefined && position !== null) {
        position = position[1].split(" ");
        // // Remove any spaces or symbols from the position
        // for (let i = 0; i < position.length; i++) {
        //   position[i] = position[i].replace(/[^a-zA-Z0-9--]/g, '');
        // }
      } else {
        position = [0, 0];
        // TODO: THROW ERROR
      }

      // Convert positition to {x: x, y: y}
      position = convertPosition(
        parseFloat(position[0]),
        parseFloat(position[1]),
        predProgram
      );

      // Cond probs are after probs = and before next ;
      // Split around that
      let probs = str.match(/probs\s*=\s*([^;]+)/);
      if (probs !== undefined && probs !== null) {
        // Get all numbers in the string, allowing decimal points. Don't allow numbers attached to letters, i.e. node4
        let numbers = probs[1].match(/(?<![a-zA-Z])(\d+\.\d+|\d+)/g);

        let numbersArr = [];
        for (let i = 0; i < numbers.length; i++) {
          let num = parseFloat(numbers[i]);
          numbersArr.push(num);
        }
        numbers = numbersArr;
        let condProbsObj = {};
        condProbsObj[id] = numbers;
        condProbs.push(condProbsObj);
      }

      nodes.push({
        id: id,
        position: position,
        data: { label: label, states: states, setStates: setStates },
      });
    }
  }

  return [nodes, edges, condProbs];

  /* TODO: Throw error if data doesn't match up, isn't complete etc.
  At this point enough data is availble, just have to fill in remaining fields
  */
}

function convertPosition(x, y, program) {
  if (program === "OLCA") {
    return { x: x, y: -y };
  } else if (program === "NETICA") {
    return { x: 2 * x, y: 2 * y };
  } else if (program === "GENIE") {
    return { x: x * 2.5, y: y * -2.5 };
  } else {
    return { x: x, y: y };
  }
}

function generateNetwork(nodes, edges, condProbs) {
  // Generate parent data for nodes using edges.
  for (let i = 0; i < nodes.length; i++) {
    let node = nodes[i];
    let parentData = {};
    let parentNum = 1;
    for (let j = 0; j < edges.length; j++) {
      let edge = edges[j];
      if (edge.target === node.id) {
        let parent = edge.source;
        let parentStates = [];
        for (let k = 0; k < nodes.length; k++) {
          if (nodes[k].id === parent) {
            parentStates = nodes[k].data.states;
            break;
          }
        }
        let parentStatesObj = {};
        for (let k = 0; k < parentStates.length; k++) {
          parentStatesObj[k + 1] = parentStates[k];
        }
        let parentObj = {};
        parentObj[parent] = parentStatesObj;
        parentData[parentNum] = parentObj;
        parentNum++;
      }
    }
    node.data.parentData = parentData;
  }

  nodes.forEach((n) => {
    //CondProb
    //Array where each int is the number of states in the corresponding parent
    let parents = Object.values(n.data.parentData)
      .map((p) => Object.values(p)[0])
      .map((p) => Object.values(p).length);

    if (parents.length === 0) {
      n.data.condProb = JSON.parse(JSON.stringify(n.data.setStates));
      return;
    }

    let condProb = [];
    let innerArr = []; //Inner most array of condProb table
    for (let i = 0; i < parents[parents.length - 1]; i++) {
      let innerObj = {};
      innerObj["P" + parents.length + "C" + (i + 1)] = 0;
      innerArr.push(innerObj);
    }

    if (parents.length === 1) {
      n.data.states.forEach((s, i) => {
        let obj = {};
        obj["S" + (i + 1)] = innerArr;
        condProb.push(obj);
      });
      n.data.condProb = condProb;
      return;
    }

    //Loop through parents backwards
    let prev = innerArr;
    let condProbTemp = [];
    for (let i = parents.length - 2; i >= 0; i--) {
      let arr = [];
      for (let j = 0; j < parents[i]; j++) {
        let obj = {};
        obj["P" + (i + 1) + "C" + (j + 1)] = JSON.parse(JSON.stringify(prev));
        arr.push(obj);
      }
      prev = arr;
      condProbTemp = arr;
    }

    n.data.states.forEach((s, i) => {
      let state = {};
      state["S" + (i + 1)] = condProbTemp;
      condProb.push(state);
    });

    n.data.condProb = condProb;
  });

  //Populating cond prob table with data
  nodes.forEach((n) => {
    let data = Object.values(
      condProbs.filter((node) => Object.keys(node)[0] === n.id)[0]
    )[0];
    data = data.map((d) => parseFloat(d));

    //Changes order of data - flips table effectively
    const numRows = n.data.states.length;
    const numCols = data.length / numRows;
    let newData = [];
    for (let i = 0; i < numRows; i++) {
      for (let j = 0; j < numCols; j++) {
        newData.push(data[i + j * numRows]);
      }
    }

    let condProbCopy = JSON.parse(JSON.stringify(n.data.condProb));
    n.data.condProb = insertValues(condProbCopy, newData);
  });

  // Add type to nodes
  nodes.forEach((n) => {
    n.type = "customNode";
  });

  // Add empty funcs to node.data
  nodes.forEach((n) => {
    n.data.funcs = {};
  });

  // Add id to edges
  edges.forEach((e) => {
    e.id = e.source + e.target;
  });
  // Add data to edges
  edges.forEach((e) => {
    e.data = { funcs: {} };
  });
  // Add type to edges
  edges.forEach((e) => {
    e.type = "customEdge";
  });
  // Add marker end to edges
  edges.forEach((e) => {
    e.markerEnd = { type: "arrowclosed", fill: "black" };
  });

  return [nodes, edges];
}

let predProgram = "GENIE";
function importNetwork(e) {
  console.log("file loaded");
  let content = e.target.result;

  // If content contains the word netica, change predProgram to netica
  if (content.includes("File generated in OLCATool")) {
    predProgram = "OLCA";
  } else if (
    content.includes("netica") ||
    content.includes("Netica") ||
    content.includes("NETICA")
  ) {
    predProgram = "NETICA";
  } else {
    predProgram = "GENIE";
  }

  //Move content to one line, remove all spaces of any kind
  // content = content.replace(/(\r\n|\n|\r)/gm, "").replace(/['"]+/g, '').replace(/\s\s+/g, ' ').trim();

  let data = parseNetwork(content);
  let nodes = data[0];
  let edges = data[1];
  let condProbs = data[2];

  let final = generateNetwork(nodes, edges, condProbs);
  nodes = final[0];
  edges = final[1];

  funcs.setImport(nodes, edges);

  predProgram = "GENIE";
}
